import { useState } from "react"
import { useRenterDashboardContext } from "../../../renters/components/renter-dashboard/useRenterDashboardContext"
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading"
import { RxOpenInNewWindow } from "react-icons/rx"
import { RadioButtonPaymentsFilter } from "../../../renters/components/payments/RadioButtonPaymentsFilter"
import { TablePaymentsPreview } from "../../../renters/components/payments/TablePaymentsPreview"
import ModalCreateNegativation from "../modals/ModalCreateNegativation"
import { TablePayments } from "../../../renters/components/payments/TablePayments"
import { usePaymentsTable } from "../../../renters/components/customHook/usePaymentsTable";
import { getStatusLabelsPayment, withInactiveStyle } from "../../../renters/components/payments/paymentUtils";
import { TABLE_HEADERS } from "../../../renters/components/constants/paymentConstants";
import { PAYMENT_STATUS, PaymentInfo } from "@/types/payment.type"
import ModalDeletePayments from "@/modules/renters/components/modals/fields/EditPayments/modals/ModalDeletePayments"

const EMPTY_ACTION = { eventName: '', data: undefined };

export function PaymentsTableDelinquencies() {
  const { renter } = useRenterDashboardContext()
  const [action, setAction] = useState<{ eventName: string, data?: unknown }>(EMPTY_ACTION);
  const {
    payments,
    showFines,
    isLoading,
    statusFilter,
    modalPayment,
    setModalPayment,
    handleStatusChange,
    handleShowFines,
    handleSyncAsaas,
  } = usePaymentsTable();

  const isCaucaoPayment = (data: PaymentInfo): boolean => {
    const planId = data.planId || ''; // Valor padrão como string vazia se for null/undefined
    // Retorna true somente se o planId NÃO começar com "caucao-facilitado-"
    return !planId.startsWith('caucao-facilitado-');
  };

  const actions = [
    {
      label: "Remover Fatura",
      visible: (data) => {
        if (!data.planId) return true;
        return !(/(caucao-facilitado|negotiationfine)/.test(data.planId));
      },
      action: (data) => setAction({ eventName: 'deleteBilling', data: data._id }),
      disabled: (data) =>
        !isCaucaoPayment(data) ||
        data.status === PAYMENT_STATUS.Inativo ||
        data.status === PAYMENT_STATUS.RECEIVED,
      permission: "delete:payment",
      // role: "finance"

    },
    {
      label: "Restaurar Fatura",
      visible: (data) => {
        if (!data.planId) return true;
        return !(/(caucao-facilitado|negotiationfine)/.test(data.planId));
      },
      action: (data) => setAction({ eventName: 'restoreBilling', data: data._id }),
      disabled: (data) =>
        !isCaucaoPayment(data) ||
        data.status != PAYMENT_STATUS.Inativo,
      role: "finance"
      // permission: "deleteBilling:payment",

    },
  ]


  const isAction = (eventName: string) => action.eventName === eventName;

  const cleanActionData = () => {
    setAction(EMPTY_ACTION);
  };

  const handleCreateNegative = () => {
    setAction({ eventName: "createNegativation", data: undefined })
  };

  return (
    <div className="tabs-border-line">
      <section className="tabs-item-style">

        <section>
          <div id="top-table-payments" className="flex flex-col sm:flex-row justify-between items-center gap-y-4 sm:gap-x-4 w-full">
            <RxOpenInNewWindow
              className="payment-open-modal cursor-pointer"
              onClick={() => setModalPayment(true)}
              title="Expandir tabela para visualizar"
            />
            <div className="flex items-center p-2">
              <ButtonWithLoader
                isLoading={isLoading}
                onClick={handleSyncAsaas}
              >
                Sincronizar com Asaas
              </ButtonWithLoader>
            </div>
            {/* Radio Button Centralizado */}
            <div className="flex justify-center flex-1">
              <RadioButtonPaymentsFilter
                statusFilter={statusFilter}
                showFines={showFines}
                handleStatusChange={handleStatusChange}
                handleShowFines={handleShowFines}
              />
            </div>

            {/* Botão Sincronizar à Direita */}
            <div className="flex items-center p-2">
              <ButtonWithLoader
                onClick={handleCreateNegative}
              >
                Criar Negativação
              </ButtonWithLoader>
            </div>
          </div>
        </section>

        <TablePaymentsPreview
          modalPayment={modalPayment}
          setModalPayment={setModalPayment}
          payments={payments as unknown as Record<string, unknown>[]}
          withInactiveStyle={withInactiveStyle}
          getStatusLabels={getStatusLabelsPayment}
        />
        <TablePayments
          payments={payments as unknown as Record<string, unknown>[]}
          renter={renter}
          actions={actions}
          tableHeaders={TABLE_HEADERS}
          withInactiveStyle={withInactiveStyle}
          getStatusLabels={getStatusLabelsPayment}
        />
      </section >

      {isAction('createNegativation') && <ModalCreateNegativation onClose={cleanActionData} open={true} data={payments} renterId={renter._id} />}
      {isAction('deleteBilling') && <ModalDeletePayments paymentId={(action.data as string)} renterId={renter._id!} onClose={cleanActionData} />}

    </div >
  );
}